import { PreloaderHandlerInterface } from './webglLoadingHandler';
import { GameClient, GameClientLoadingState } from '../gameClient';
import { WebGuestWarningPopup } from '../../general/modules/webGuestWarningPopup';
import { UserSession } from '../../general/modules/user/userSession';

export enum LoadingProgressEvents {
    PRE_START = 'LOADING_PROGRESS.PRE_START',
    COMPILING_PROGRESS = 'LOADING_PROGRESS.COMPILING_PROGRESS',
    CLIENT_PROGRESS = 'LOADING_PROGRESS.CLIENT_PROGRESS',
    COMPATIBILITY_CHECK_FAILED = 'LOADING_PROGRESS.COMPATIBILITY_CHECK_FAILED'
}

export class LoadingProgressEventEmitter {
    public static addLoadingProgressHandler(handler: PreloaderHandlerInterface) {
        $(document).on(LoadingProgressEvents.PRE_START, (_event, data) => {
            handler.onPreStart(data.initialPercents);
        });
        $(document).on(LoadingProgressEvents.COMPILING_PROGRESS, (_event, data) => {
            handler.onCompileProgressChange(data.compileProgressShare);
        });
        $(document).on(LoadingProgressEvents.CLIENT_PROGRESS, (_event, data) => {
            handler.onClientLoadingProgressChanged(data.clientLoadingPercent);

            if (data.clientLoadingPercent === 100) {
                GameClient.getInstance().setLoadingState(GameClientLoadingState.LOADED);
                UserSession.getInstance().isNewProgress()
                    .then((isNewSession) => {
                        if (!isNewSession) {
                            WebGuestWarningPopup.showWebGuestNotificationWindow();
                        }
                    });
            }
        });
        $(document).on(LoadingProgressEvents.COMPATIBILITY_CHECK_FAILED, () => {
            handler.onCompatibilityCheckFailed();
        });
    }

    public static firePreStartEvent(initialPercents: number): void {
        $(document).trigger(LoadingProgressEvents.PRE_START, {
            initialPercents
        });
    }

    public static fireCompilingProgressEvent(compileProgressShare: number): void {
        $(document).trigger(LoadingProgressEvents.COMPILING_PROGRESS, {
            compileProgressShare
        });
    }

    public static fireClientLoadingProgressEvent(clientLoadingPercent: number) {
        $(document).trigger(LoadingProgressEvents.CLIENT_PROGRESS, {
            clientLoadingPercent
        });
    }

    public static fireCompatibilityCheckFailedEvent() {
        $(document).trigger(LoadingProgressEvents.COMPATIBILITY_CHECK_FAILED);
    }
}
